export const OTHER_ID = 'Other';
const getValueIncludesOther = (value, optionsNames)=>value.some((_value)=>!optionsNames.includes(_value));
export const getIsOtherOptionSelected = (value, optionsNames)=>value.length > 0 && getValueIncludesOther(value, optionsNames);
export const getOtherLabel = (addOtherLabel, t)=>{
    const otherLabelDefault = t?.('add-other.default-other-option-label');
    return addOtherLabel || otherLabelDefault || OTHER_ID;
};
export const getOtherValue = (value, addOtherLabel)=>{
    const addedSymbolsLength = 2; // we add ': ' to other value
    const otherLabelLength = addOtherLabel ? addOtherLabel.length + addedSymbolsLength : 0;
    const otherItem = value.find((item)=>item.startsWith(`${addOtherLabel}: `)) || '';
    return otherItem.slice(otherLabelLength);
};
export const getOptionsNames = (options)=>options.map((option)=>option.label);
export const getOptionsValues = (options)=>options.map((option)=>option.value ?? option.label);

//# sourceMappingURL=checkbox-group-field-utils.js.map